<template>
<Layout>
  <el-form :model="form" :rules="rules" ref="formRef" label-width="220px" @submit.prevent="onSubmit" class="max-w-6xl mx-auto p-6">
    <!-- Membership / KYM Details -->
    <el-card class="mb-4" header="Membership / KYM Details">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <el-form-item label="Membership Number" prop="membershipNumber">
            <el-input v-model="form.membershipNumber" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="KYM Number" prop="kymNumber">
            <el-input v-model="form.kymNumber" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Issued Date" prop="issuedDate">
            <el-date-picker v-model="form.issuedDate" type="date" placeholder="Select date" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Received Date" prop="receivedDate">
            <el-date-picker v-model="form.receivedDate" type="date" placeholder="Select date" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Aadhar Card Number" prop="aadharCardNumber">
            <el-input v-model="form.aadharCardNumber" maxlength="12" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>

    <!-- Applicant Details -->
    <el-card class="mb-4" header="Applicant Details">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <el-form-item label="Head of Family Full Name" prop="headOfFamily">
            <el-input v-model="form.headOfFamily" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Native Place" prop="nativePlace">
            <el-input v-model="form.nativePlace" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Date of Birth" prop="dob">
            <el-date-picker v-model="form.dob" type="date" placeholder="Select date" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Age" prop="age">
            <el-input-number v-model="form.age" :min="0" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item label="Residence Address" prop="residenceAddress">
            <el-input v-model="form.residenceAddress" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Telephone Number" prop="telephone">
            <el-input v-model="form.telephone" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Mobile Number" prop="mobile">
            <el-input v-model="form.mobile" />
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item label="Email (Self / Family Member)" prop="email">
            <el-input v-model="form.email" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Occupation" prop="occupation">
            <el-select v-model="form.occupation" placeholder="Select">
              <el-option label="Self Employed" value="self-employed" />
              <el-option label="Business" value="business" />
              <el-option label="Employee" value="employee" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Occupation Address" prop="occupationAddress">
            <el-input v-model="form.occupationAddress" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Office Telephone Number" prop="officeTelephone">
            <el-input v-model="form.officeTelephone" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Office Mobile Number" prop="officeMobile">
            <el-input v-model="form.officeMobile" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>

    <!-- Family Details -->
    <el-card class="mb-4" header="Family Details">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="8">
          <el-form-item label="Total Family Members" prop="totalFamilyMembers">
            <el-input-number v-model="form.totalFamilyMembers" :min="1" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Total Earning Members" prop="totalEarningMembers">
            <el-input-number v-model="form.totalEarningMembers" :min="0" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Total Monthly Income (INR)" prop="totalMonthlyIncome">
            <el-input-number v-model="form.totalMonthlyIncome" :min="0" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="mt-6 table-responsive">
        <el-table :data="form.familyMembers" border style="width: 100%;">
          <el-table-column prop="sno" label="S.No." width="60">
            <template #default="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="Full Name">
            <template #default="scope">
              <el-input v-model="form.familyMembers[scope.$index].fullName" placeholder="Full Name" />
            </template>
          </el-table-column>
          <el-table-column label="Age" width="120">
            <template #default="scope">
              <el-input-number v-model="form.familyMembers[scope.$index].age" :min="0" style="width: 100%;" />
            </template>
          </el-table-column>
          <el-table-column label="Occupation">
            <template #default="scope">
              <el-input v-model="form.familyMembers[scope.$index].occupation" placeholder="Occupation" />
            </template>
          </el-table-column>
          <el-table-column label="Monthly Income (INR)">
            <template #default="scope">
              <el-input-number v-model="form.familyMembers[scope.$index].monthlyIncome" :min="0" style="width: 100%;" />
            </template>
          </el-table-column>
          <el-table-column label="Relationship">
            <template #default="scope">
              <el-input v-model="form.familyMembers[scope.$index].relationship" placeholder="Relationship" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
        <!-- Document Uploads -->
    <el-card class="mb-4" header="Document Uploads">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last 6 Months Electric Bills" prop="electricBills">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="6"
              multiple
              :file-list="form.electricBills"
              :on-change="(file, fileList) => form.electricBills = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last 6 Months Telephone Bills" prop="telephoneBills">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="6"
              multiple
              :file-list="form.telephoneBills"
              :on-change="(file, fileList) => form.telephoneBills = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last 6 Months Mobile Bills" prop="mobileBills">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="6"
              multiple
              :file-list="form.mobileBills"
              :on-change="(file, fileList) => form.mobileBills = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Society Maintenance Bills" prop="maintenanceBills">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="6"
              multiple
              :file-list="form.maintenanceBills"
              :on-change="(file, fileList) => form.maintenanceBills = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Rent Receipt" prop="rentReceipt">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="3"
              multiple
              :file-list="form.rentReceipt"
              :on-change="(file, fileList) => form.rentReceipt = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last F.Y. Salary Certificate" prop="salaryCertificate">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="3"
              multiple
              :file-list="form.salaryCertificate"
              :on-change="(file, fileList) => form.salaryCertificate = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last F.Y. Income Tax Return" prop="incomeTaxReturn">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="3"
              multiple
              :file-list="form.incomeTaxReturn"
              :on-change="(file, fileList) => form.incomeTaxReturn = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Last 6 Months Bank Statement (Each Member)" prop="bankStatements">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="12"
              multiple
              :file-list="form.bankStatements"
              :on-change="(file, fileList) => form.bankStatements = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Original Cancelled Cheque" prop="cancelledCheque">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="1"
              :file-list="form.cancelledCheque"
              :on-change="(file, fileList) => form.cancelledCheque = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="PAN Card" prop="panCard">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="1"
              :file-list="form.panCard"
              :on-change="(file, fileList) => form.panCard = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Aadhar Card" prop="aadharCard">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="1"
              :file-list="form.aadharCard"
              :on-change="(file, fileList) => form.aadharCard = fileList"
              list-type="text"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Photos of All Family Members" prop="familyPhotos">
            <el-upload
              action=""
              :auto-upload="false"
              :limit="10"
              multiple
              :file-list="form.familyPhotos"
              :on-change="(file, fileList) => form.familyPhotos = fileList"
              list-type="picture-card"
            >
              <el-button>Upload</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mb-4" header="Aid from Other Trust">
  <el-row :gutter="20">
    <el-col :xs="24" :sm="12">
      <el-form-item label="Are you taking aid from any other trust?"  prop="aidFromOtherTrust">
        <el-radio-group v-model="form.aidFromOtherTrust">
          <el-radio label="no">No</el-radio>
          <el-radio label="yes">Yes</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-col>
    <template v-if="form.aidFromOtherTrust === 'yes'">
      <el-col :xs="24" :sm="12">
        <el-form-item label="Name of the Trust" prop="otherTrustName">
          <el-input v-model="form.otherTrustName" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Purpose of Aid" prop="aidPurpose">
          <el-input v-model="form.aidPurpose" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Amount of Aid" prop="aidAmount">
          <el-input-number v-model="form.aidAmount" :min="0" style="width: 100%;" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Contact Person" prop="aidContactPerson">
          <el-input v-model="form.aidContactPerson" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="Contact Person Tel. No." prop="aidContactTel">
          <el-input v-model="form.aidContactTel" />
        </el-form-item>
      </el-col>
    </template>
  </el-row>
</el-card>
    <el-form-item>
      <el-button type="primary" native-type="submit">Submit</el-button>
    </el-form-item>
  </el-form>
  </Layout>
</template>

<script setup>
import Layout from './../layouts/LayoutView.vue'
import emailjs from 'emailjs-com'
import { reactive, ref } from 'vue'

const formRef = ref()
const form = reactive({
  membershipNumber: '',
  kymNumber: '',
  issuedDate: '',
  receivedDate: '',
  aadharCardNumber: '',
  headOfFamily: '',
  nativePlace: '',
  dob: '',
  age: null,
  residenceAddress: '',
  telephone: '',
  mobile: '',
  email: '',
  occupation: '',
  occupationAddress: '',
  officeTelephone: '',
  officeMobile: '',
  // Family details
  totalFamilyMembers: 1,
  totalEarningMembers: 0,
  totalMonthlyIncome: 0,
  familyMembers: Array.from({ length: 6 }, () => ({
    fullName: '',
    age: null,
    occupation: '',
    monthlyIncome: null,
    relationship: ''
  })),
   // ...existing fields...
  electricBills: [],
  telephoneBills: [],
  mobileBills: [],
  maintenanceBills: [],
  rentReceipt: [],
  salaryCertificate: [],
  incomeTaxReturn: [],
  bankStatements: [],
  cancelledCheque: [],
  panCard: [],
  aadharCard: [],
  familyPhotos: [],
  aidFromOtherTrust: 'no',
otherTrustName: '',
aidPurpose: '',
aidAmount: null,
aidContactPerson: '',
aidContactTel: '',
})

const rules = {
  membershipNumber: [{ required: true, message: 'Membership Number is required', trigger: 'blur' }],
  kymNumber: [{ required: true, message: 'KYM Number is required', trigger: 'blur' }],
  issuedDate: [{ required: true, message: 'Issued Date is required', trigger: 'change' }],
  receivedDate: [{ required: true, message: 'Received Date is required', trigger: 'change' }],
  aadharCardNumber: [
    { required: true, message: 'Aadhar Card Number is required', trigger: 'blur' },
    { pattern: /^\d{12}$/, message: 'Aadhar must be 12 digits', trigger: 'blur' }
  ],
  headOfFamily: [{ required: true, message: 'Head of Family Name is required', trigger: 'blur' }],
  nativePlace: [{ required: true, message: 'Native Place is required', trigger: 'blur' }],
  dob: [{ required: true, message: 'Date of Birth is required', trigger: 'change' }],
  age: [{ required: true, message: 'Age is required', trigger: 'blur' }],
  residenceAddress: [{ required: true, message: 'Residence Address is required', trigger: 'blur' }],
  telephone: [{ required: true, message: 'Telephone Number is required', trigger: 'blur' }],
  mobile: [
    { required: true, message: 'Mobile Number is required', trigger: 'blur' },
    { pattern: /^\d{10}$/, message: 'Mobile must be 10 digits', trigger: 'blur' }
  ],
  email: [
    { required: true, message: 'Email is required', trigger: 'blur' },
    { type: 'email', message: 'Invalid email', trigger: 'blur' }
  ],
  occupation: [{ required: true, message: 'Occupation is required', trigger: 'change' }],
  occupationAddress: [{ required: true, message: 'Occupation Address is required', trigger: 'blur' }],
  officeTelephone: [{ required: true, message: 'Office Telephone Number is required', trigger: 'blur' }],
  officeMobile: [{ required: true, message: 'Office Mobile Number is required', trigger: 'blur' }],
  totalFamilyMembers: [{ required: true, message: 'Total Family Members is required', trigger: 'blur' }],
  totalEarningMembers: [{ required: true, message: 'Total Earning Members is required', trigger: 'blur' }],
  totalMonthlyIncome: [{ required: true, message: 'Total Monthly Income is required', trigger: 'blur' }],
  // For each family member, validate inside your submit logic or use dynamic rules
  electricBills: [{ required: true, message: 'Please upload last 6 months electric bills', trigger: 'change' }],
  telephoneBills: [{ required: true, message: 'Please upload last 6 months telephone bills', trigger: 'change' }],
  mobileBills: [{ required: true, message: 'Please upload last 6 months mobile bills', trigger: 'change' }],
  maintenanceBills: [{ required: true, message: 'Please upload society maintenance bills', trigger: 'change' }],
  rentReceipt: [{ required: true, message: 'Please upload rent receipt', trigger: 'change' }],
  salaryCertificate: [{ required: true, message: 'Please upload last F.Y. salary certificate', trigger: 'change' }],
  incomeTaxReturn: [{ required: true, message: 'Please upload last F.Y. income tax return', trigger: 'change' }],
  bankStatements: [{ required: true, message: 'Please upload last 6 months bank statements for each member', trigger: 'change' }],
  cancelledCheque: [{ required: true, message: 'Please upload original cancelled cheque', trigger: 'change' }],
  panCard: [{ required: true, message: 'Please upload PAN card', trigger: 'change' }],
  aadharCard: [{ required: true, message: 'Please upload Aadhar card', trigger: 'change' }],
  familyPhotos: [{ required: true, message: 'Please upload photos of all family members', trigger: 'change' }],
  aidFromOtherTrust: [{ required: true, message: 'Please select if you are taking aid from another trust', trigger: 'change' }],
  otherTrustName: [{ required: true, message: 'Please enter the name of the trust', trigger: 'blur' }],
  aidPurpose: [{ required: true, message: 'Please enter the purpose of aid', trigger: 'blur' }],
  aidAmount: [{ required: true, message: 'Please enter the amount of aid', trigger: 'blur' }],
  aidContactPerson: [{ required: true, message: 'Please enter the contact person', trigger: 'blur' }],
  aidContactTel: [{ required: true, message: 'Please enter the contact person telephone number', trigger: 'blur' }],
  declarationAccepted: [
    { required: true, type: 'boolean', validator: (rule, value) => !!value, message: 'You must accept the declaration', trigger: 'change' }
  ],
}

function onSubmit() {
  // Validate form before sending
  formRef.value.validate(async (valid) => {
    if (!valid) return;

      // Format family members as a readable string
    const familyMembersString = form.familyMembers
      .map((m, i) =>
        `#${i + 1}: ${m.fullName}, Age: ${m.age}, Occupation: ${m.occupation}, Income: ${m.monthlyIncome}, Relationship: ${m.relationship}`
      )
      .join('\n');

    // Prepare all fields for EmailJS
    const templateParams = {
      membershipNumber: form.membershipNumber,
      kymNumber: form.kymNumber,
      issuedDate: form.issuedDate,
      receivedDate: form.receivedDate,
      aadharCardNumber: form.aadharCardNumber,
      headOfFamily: form.headOfFamily,
      nativePlace: form.nativePlace,
      dob: form.dob,
      age: form.age,
      residenceAddress: form.residenceAddress,
      telephone: form.telephone,
      mobile: form.mobile,
      email: form.email,
      occupation: form.occupation,
      occupationAddress: form.occupationAddress,
      officeTelephone: form.officeTelephone,
      officeMobile: form.officeMobile,
      totalFamilyMembers: form.totalFamilyMembers,
      totalEarningMembers: form.totalEarningMembers,
      totalMonthlyIncome: form.totalMonthlyIncome,
      familyMembers: familyMembersString,
      // Document uploads: send file names or counts (attachments not supported directly)
      electricBills: form.electricBills.map(f => f.name).join(', '),
      telephoneBills: form.telephoneBills.map(f => f.name).join(', '),
      mobileBills: form.mobileBills.map(f => f.name).join(', '),
      maintenanceBills: form.maintenanceBills.map(f => f.name).join(', '),
      rentReceipt: form.rentReceipt.map(f => f.name).join(', '),
      salaryCertificate: form.salaryCertificate.map(f => f.name).join(', '),
      incomeTaxReturn: form.incomeTaxReturn.map(f => f.name).join(', '),
      bankStatements: form.bankStatements.map(f => f.name).join(', '),
      cancelledCheque: form.cancelledCheque.map(f => f.name).join(', '),
      panCard: form.panCard.map(f => f.name).join(', '),
      aadharCard: form.aadharCard.map(f => f.name).join(', '),
      familyPhotos: form.familyPhotos.map(f => f.name).join(', '),
      aidFromOtherTrust: form.aidFromOtherTrust,
      otherTrustName: form.otherTrustName,
      aidPurpose: form.aidPurpose,
      aidAmount: form.aidAmount,
      aidContactPerson: form.aidContactPerson,
      aidContactTel: form.aidContactTel,
      declarationAccepted: form.declarationAccepted ? 'Yes' : 'No',
    };

      console.log('Template Params:', templateParams);
    try {
      await emailjs.send(
        'service_7drkfng',
        'template_emf64eu',
        templateParams,
        'tizvfXAZW3GX-ssYo'
      );
      alert('Form sent successfully!');
    } catch (error) {
      alert('Failed to send form: ' + error.text);
    }
  });
}
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
@media (max-width: 600px) {
  .el-card {
    padding: 0.5rem !important;
  }
  .el-form-item__label {
    font-size: 0.95rem;
  }
}
</style>